import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "w-100 d-flex flex-row justify-content-between align-items-center" }
const _hoisted_3 = { class: "mb-0 flex-shrink-0" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "px-3 pt-3 font-weight-bold text-muted" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "cil-location-pin mr-5",
  style: {"font-size":"40px"}
}, null, -1)
const _hoisted_8 = { class: "flex-grow-1" }
const _hoisted_9 = { class: "mb-1" }
const _hoisted_10 = { class: "mb-1" }
const _hoisted_11 = { class: "mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectInfo = _resolveComponent("ProjectInfo")!
  const _component_OrganizationCard = _resolveComponent("OrganizationCard")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Panel = _resolveComponent("Panel", true)!
  const _component_translate = _resolveComponent("translate")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: _normalizeClass(["flat border", { 'bg-light': _ctx.panel?.displayType?.toLowerCase() === 'section' }]),
    id: _ctx.id
  }, {
    header: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.panel.ordinal ? _ctx.panel.ordinal + ' ' : '') + _toDisplayString(_ctx.labelConditional), 1)
    ]),
    content: _withCtx(() => [
      (_ctx.lot)
        ? (_openBlock(), _createBlock(_component_ProjectInfo, {
            key: 0,
            class: "card flat border p-5 mb-4",
            project: _ctx.lot
          }, null, 8, ["project"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.panel.children || []).filter(c => _ctx.hasValue(c)), (content, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i + content.label + content.contentId
        }, [
          (content.contentId === 'OPT-300-Procedure-Buyer' && _ctx.clientOrganization)
            ? (_openBlock(), _createBlock(_component_OrganizationCard, {
                key: 0,
                organization: _ctx.clientOrganization,
                header: (content.ordinal ? content.ordinal + ' ' : '') + _ctx.translateLabel(content),
                class: "card p-5 mb-4"
              }, null, 8, ["organization", "header"]))
            : (content.contentType?.toLowerCase() === 'field' && _ctx.fieldVisible(content))
              ? (_openBlock(), _createBlock(_component_Field, {
                  key: 1,
                  field: content,
                  id: (_ctx.id || '') + '-' + content.contentId + '-' + i
                }, null, 8, ["field", "id"]))
              : (content.contentType?.toLowerCase() === 'group')
                ? (_openBlock(), _createBlock(_component_Panel, {
                    key: 2,
                    panel: content,
                    project: _ctx.project,
                    id: (_ctx.id || '') + '-' + content.contentId + '-' + i,
                    class: "p-3 mb-4"
                  }, null, 8, ["panel", "project", "id"]))
                : _createCommentVNode("", true)
        ]))
      }), 128)),
      (_ctx.isLot)
        ? (_openBlock(), _createBlock(_component_Accordion, {
            key: 1,
            class: "card flat mb-4",
            "active-index": 0
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AccordionTab, null, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h4", _hoisted_3, [
                      _createVNode(_component_translate, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Grundstücke")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  (!_ctx.linkedProperties.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("p", _hoisted_5, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Keine Grundstücke verknüpft.")
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkedProperties, (property, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: property.id,
                      class: _normalizeClass(["w-100 p-3 mx-0 d-flex flex-row align-items-center clickable", { 'list-row': i < _ctx.linkedProperties.length - 1 }]),
                      onClick: ($event: any) => (_ctx.$router.push('/grundstuecke/' + property.id))
                    }, [
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(property.location?.name || ''), 1),
                        _createElementVNode("h5", _hoisted_10, _toDisplayString(property.name), 1),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.sizeFormatted(property.size)) + ", " + _toDisplayString(property.plat), 1)
                      ])
                    ], 10, _hoisted_6))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["id", "class"]))
}